import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["row", "content"]

  connect() {
    this.startAnimation()
    this.addPauseControl()
  }

  // Auto-scrolling content that runs for >5s needs a pause mechanism (WCAG 2.2.2).
  // Skip it when the user prefers reduced motion — the animation is already stopped
  // by the global baseline, so there's nothing to pause.
  addPauseControl() {
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return
    }
    this.paused = false
    const btn = document.createElement("button")
    btn.type = "button"
    btn.className = "absolute bottom-4 right-4 z-10 w-10 h-10 rounded-full bg-white/90 hover:bg-white "
      + "flex items-center justify-center shadow-md text-[#020D19] "
      + "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0FEED7]"
    this.updatePauseButton(btn)
    btn.addEventListener("click", () => this.togglePause(btn))
    this.pauseButton = btn
    this.element.appendChild(btn)
  }

  togglePause(btn) {
    this.paused = !this.paused
    this.element.querySelectorAll(".scroll-left, .scroll-right").forEach((wrapper) => {
      wrapper.style.animationPlayState = this.paused ? "paused" : "running"
    })
    this.updatePauseButton(btn)
  }

  updatePauseButton(btn) {
    // The accessible name is the action the button performs.
    btn.setAttribute("aria-label", this.paused ? "Play the scrolling gallery" : "Pause the scrolling gallery")
    btn.innerHTML = this.paused
      ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>'
      : '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6 5h4v14H6zM14 5h4v14h-4z"/></svg>'
  }

  startAnimation() {
    this.rowTargets.forEach((row, index) => {
      const direction = row.dataset.direction
      const innerWrapper = row.querySelector(':scope > .flex') 
      const content = row.querySelector(':scope [data-carousel-owl-target="content"]')

      this.duplicateContent(content, row)

      if (direction === "left") {
        innerWrapper.classList.add("scroll-left")
      } else if (direction === "right") {
        innerWrapper.classList.add("scroll-right")
      }
    })
  }

  duplicateContent(content, row) {
    const contentWidth = content.offsetWidth
    const rowWidth = row.offsetWidth

    let duplicatesNeeded = Math.ceil((rowWidth * 3) / contentWidth)

    const MAX_DUPLICATES = 10
    duplicatesNeeded = Math.min(duplicatesNeeded, MAX_DUPLICATES)

    for (let i = 0; i < duplicatesNeeded; i++) {
      const clone = content.cloneNode(true)
      // The clones exist only for the seamless-scroll visual — hide the duplicated
      // links from assistive tech and take them out of the tab order so the marquee
      // isn't announced/tabbed through many times over (WCAG 4.1.2 / 2.4.3). The
      // original `content` copy stays fully accessible.
      clone.setAttribute("aria-hidden", "true")
      clone.querySelectorAll("a, button, [tabindex]").forEach((el) => {
        el.setAttribute("tabindex", "-1")
      })
      content.parentNode.appendChild(clone)
    }
  }
}
